import { useTranslation } from 'react-i18next';
import { Avatar, useTheme } from '@mui/material';
import { LightbulbOutlined as LightBulbIcon } from '@mui/icons-material';
import {
  DesktopDeviceIllustration,
  EmptyView,
  getDeviceType,
  IEmptyViewAction,
  useHasFeature,
  DianaFeaturesEnum,
  generateTestIds,
  DianaAssistantType,
  useDianaAssistantStore,
  WorkflowGenerateIllustration,
} from '@diana/core';
import { WORKFLOWS_PAGE_NS } from './i18n';

const WorkflowsEmptyViewTestIds = generateTestIds('WorkflowsEmptyView', [
  'takeATourButton',
  'buildMyFirstWorkflowButton',
  'checkKnowledgeBaseButton',
]);

function BulbIcon() {
  const { palette } = useTheme();

  return (
    <Avatar
      sx={{
        width: 24,
        height: 24,
        color: palette.getContrastText(palette.primary.main),
        backgroundColor: palette.primary.main,
      }}
    >
      <LightBulbIcon sx={{ fontSize: '16px' }} color="inherit" />
    </Avatar>
  );
}

export const WorkflowsEmptyView = () => {
  const { t } = useTranslation(WORKFLOWS_PAGE_NS);
  const setAssistantType = useDianaAssistantStore((store) => store.setAssistantType);
  const { isMobile } = getDeviceType();

  const canCreateFlow = useHasFeature(DianaFeaturesEnum.WorkflowCreate);

  return (
    <EmptyView
      illustration={isMobile ? <DesktopDeviceIllustration /> : <WorkflowGenerateIllustration />}
      title={isMobile ? '' : t('titles.buildWorkflow')}
      description={
        isMobile ? t('descriptions.workflowAvailability') : t('descriptions.buildWorkflow')
      }
      actionsDirection={'row'}
      actions={
        [
          !isMobile && canCreateFlow
            ? {
                label: t('buttons.workflowBuilder'),
                onClick: () => setAssistantType(DianaAssistantType.BuildWorkflow),
                dataTestId: WorkflowsEmptyViewTestIds.buildMyFirstWorkflowButton,
              }
            : null,
        ].filter((action) => Boolean(action)) as IEmptyViewAction[]
      }
      tip={{
        icon: <BulbIcon />,
        description: t('descriptions.checkKnowledgeBase'),
        dataTestId: WorkflowsEmptyViewTestIds.checkKnowledgeBaseButton,
        link: {
          label: t('descriptions.checkKnowledgeBase'),
          href: 'https://help.rise-x.io/',
          target: '_blank',
          isIcon: true,
        },
      }}
    />
  );
};
